import { logWrapper } from '../utils';

export default {
  workflowModel: [
    'runtimeConstant',
    '$filter',
    function (runtimeConstant, $filter) {
      function Workflow(data) {
        this.id = data.Id;
        this.name = data.Name;
        this.description = data.Description;
        this.startType = data.StartType ? data.StartType : 0;
        this.isActive = data.IsActive ? true : false;
        this.guid = data.RowGuid;

        this.startTypes = [];
        this.startTypes[0] = 'SEND AND REVIEW';
        this.startTypes[1] = 'REVIEW';
        this.startTypes[2] = 'SEND';
      }

      function title() {
        return this.name;
      }

      function details() {
        return this.description;
      }

      function tags() {
        return [
          $filter('translate')('TRIGGER') +
            ': ' +
            $filter('translate')(this.startTypes[this.startType]),
          this.isActive ? 'ACTIVE' : 'INACTIVE',
        ];
      }

      function filter() {
        return (
          this.name +
          ' ' +
          this.description +
          ' ' +
          $filter('translate')(this.startTypes[this.startType])
        );
      }

      function run() {
        try {
          Workflow.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            filter: logWrapper(filter, runtimeConstant.isDebugModelsInternals),
          };

          return Workflow;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
